import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/lib/i18n";

const STORAGE_KEY = "aim_cookie_consent";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // small delay to let the page render first
      const id = window.setTimeout(() => setVisible(true), 600);
      return () => window.clearTimeout(id);
    }
  }, []);

  const persist = (choice) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (err) {
      console.warn("[CookieBanner] no s'ha pogut desar el consent:", err);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label={t("cookieBanner.ariaLabel")}
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-[#0B2545] text-[#F9F8F6] shadow-2xl rounded-lg p-5 border border-[#0B2545]/40"
    >
      <p className="font-sans-display text-sm tracking-tight leading-relaxed">
        {t("cookieBanner.body")}{" "}
        <Link
          to="/politica-cookies"
          className="underline underline-offset-2 hover:text-[#B4C5A4]"
          data-testid="cookie-banner-policy-link"
        >
          {t("cookieBanner.policyLink")}
        </Link>
        .
      </p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <button
          type="button"
          onClick={() => persist("essential")}
          data-testid="cookie-banner-essential-btn"
          className="lift-btn flex-1 h-10 px-4 text-sm font-sans-display font-medium tracking-wide rounded-md border border-[#F9F8F6]/30 hover:bg-white/5 transition"
        >
          {t("cookieBanner.essentialBtn")}
        </button>
        <button
          type="button"
          onClick={() => persist("accepted")}
          data-testid="cookie-banner-accept-btn"
          className="lift-btn flex-1 h-10 px-4 text-sm font-sans-display font-medium tracking-wide rounded-md bg-[#B4C5A4] text-[#0B2545] hover:bg-[#a3b793] transition"
        >
          {t("cookieBanner.acceptBtn")}
        </button>
      </div>
    </div>
  );
}
